import React, { useContext, useState } from 'react'
import { AuthContext, verifiedAgencyUser } from 'components/common/auth/AuthContext'
import { DropdownPill, DropdownPillSyncProps } from 'components/common/dropdown_pill/DropdownPill'
import withRadioGroup from 'components/fields/withRadioGroup'

const SharedWithSupplierSelectionMap = {
  all: 'Visibility',
  shared: 'Shared with Supplier',
  notShared: 'Not Shared with Supplier'
} as const
export type SharedWithSupplierSelectionMapKey = keyof typeof SharedWithSupplierSelectionMap

interface SharedWithSupplierFilterBaseProps {
  onChange: (selection: SharedWithSupplierSelectionMapKey) => void
}

type SharedWithSupplierFilterProps = SharedWithSupplierFilterBaseProps & Partial<DropdownPillSyncProps>

const ShareFilterItem = withRadioGroup('share')

export const SharedWithSupplierFilter: React.FC<SharedWithSupplierFilterProps> = ({ onChange, ...dropdownProps }) => {
  const [selection, setSelection] = useState<SharedWithSupplierSelectionMapKey>('all')

  const label = SharedWithSupplierSelectionMap[selection]

  const authContext = useContext(AuthContext)
  const isAgencyUser = verifiedAgencyUser(authContext)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const selection = (e.target.value in SharedWithSupplierSelectionMap) ? e.target.value as SharedWithSupplierSelectionMapKey : 'all'
    setSelection(selection)
    onChange(selection)
  }

  const syncProps: DropdownPillSyncProps = {
    id: dropdownProps.id ?? 'none',
    isExpanded: dropdownProps.isExpanded ?? false,
    onClick: dropdownProps.onClick ?? (() => { console.error('Dropdown onClick handler not set') })
  }

  return (
    <>
      {isAgencyUser &&
        <DropdownPill labelText={label} {...syncProps}>
          <div className='shared-with-supplier-filters review-filter' onChange={handleChange}>
            <ShareFilterItem label='All Visibility Types' optionValue='all' selectedValue={selection} />
            <ShareFilterItem label='Shared with Supplier' optionValue='shared' selectedValue={selection} />
            <ShareFilterItem label='Not Shared with Supplier' optionValue='notShared' selectedValue={selection} />
          </div>
        </DropdownPill>}
    </>
  )
}
